import { Link } from 'react-router-dom';
import { gruender } from '../../../mocks/ueber-uns';

export default function VomGruenderSection() {
  return (
    <section className="py-16 sm:py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6">

        {/* Header label */}
        <div className="flex items-center justify-center gap-3 mb-10 sm:mb-14">
          <div className="h-px w-12 bg-[#C8860A]" />
          <span className="text-[#C8860A] text-sm font-semibold uppercase tracking-[0.18em]">
            Vom Gründer
          </span>
          <div className="h-px w-12 bg-[#C8860A]" />
        </div>

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-20 items-center max-w-6xl mx-auto">

          {/* Left — Photo + Stats */}
          <div className="relative flex flex-col items-center lg:items-start">
            {/* Photo frame */}
            <div className="relative w-full max-w-[340px] sm:max-w-[380px]">
              {/* Accent corner top-left */}
              <div className="absolute -top-2 -left-2 sm:-top-4 sm:-left-4 w-16 h-16 sm:w-20 sm:h-20 border-t-4 border-l-4 border-[#C8860A] rounded-tl-lg z-10" />
              {/* Accent corner bottom-right */}
              <div className="absolute -bottom-2 -right-2 sm:-bottom-4 sm:-right-4 w-16 h-16 sm:w-20 sm:h-20 border-b-4 border-r-4 border-[#0D2B4E] rounded-br-lg z-10" />

              <div className="w-full aspect-[3/4] rounded-xl overflow-hidden">
                <img
                  src={gruender.image}
                  alt={`${gruender.name} – ${gruender.role}`}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Name tag */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-lg px-4 py-3">
                <p className="font-bold text-[#0D2B4E] text-base leading-tight">{gruender.name}</p>
                <p className="text-[#C8860A] text-xs font-medium mt-0.5">{gruender.role}</p>
              </div>
            </div>

            {/* Quick stats below photo */}
            <div className="mt-6 sm:mt-8 grid grid-cols-3 gap-3 sm:gap-4 w-full max-w-[340px] sm:max-w-[380px]">
              {[
                { value: '2021', label: 'Gegründet' },
                { value: '15+', label: 'Jahre Erfahrung' },
                { value: '3', label: 'Sparten' },
              ].map((stat) => (
                <div key={stat.label} className="text-center bg-[#0D2B4E]/4 rounded-lg py-3 px-2">
                  <p className="text-lg sm:text-xl font-bold text-[#0D2B4E]">{stat.value}</p>
                  <p className="text-xs text-gray-500 mt-0.5 leading-tight">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Quote & Story */}
          <div className="flex flex-col justify-center">
            {/* Big Quote */}
            <div className="relative mb-6 sm:mb-8">
              <div className="absolute -top-2 -left-1 text-6xl sm:text-7xl text-[#C8860A]/20 font-serif leading-none select-none">"</div>
              <blockquote className="pl-6 border-l-4 border-[#C8860A]">
                <p className="text-lg sm:text-xl lg:text-2xl font-light text-gray-800 leading-relaxed italic">
                  {gruender.quote}
                </p>
              </blockquote>
            </div>

            {/* Story paragraphs */}
            <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
              <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                {gruender.bio}
              </p>
              <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                {gruender.motivation}
              </p>
            </div>

            {/* Skill tags */}
            <div className="flex flex-wrap gap-2 mb-6 sm:mb-8">
              {gruender.skills.map((skill) => (
                <span
                  key={skill}
                  className="text-xs font-medium text-[#0D2B4E] bg-[#0D2B4E]/8 px-3 py-1.5 rounded-full"
                >
                  {skill}
                </span>
              ))}
            </div>

            {/* CTA row */}
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/ueber-uns"
                className="inline-flex items-center justify-center gap-2 bg-[#0D2B4E] text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-[#0a2240] transition-colors whitespace-nowrap cursor-pointer"
              >
                <span>Mehr über uns erfahren</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </div>
              </Link>
              <a
                href={`tel:${gruender.phone}`}
                className="inline-flex items-center justify-center gap-2 border-2 border-[#0D2B4E] text-[#0D2B4E] px-6 py-3 rounded-lg text-sm font-semibold hover:bg-[#0D2B4E]/5 transition-colors whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line" />
                </div>
                <span>Direkt anrufen</span>
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
